import React from 'react';
import ConvertMessage from './ConvertMessage';
import DatasetAttachmentsTable from './DatasetAttachmentsTable';
import DatasetWizardContentContainer from '../../components/DatasetWizardContentContainer';
import Selectors from '../hooks/selectors';
import Fetch from '../../datasource/hooks/fetch';

const AddDatasetAttachments = ({
  category,
  code,
  readErrors,
  title,
}) => {
  const { canConvert, isDirty, readStatus } = Selectors.useAddDatasetAttachments({ category, code });
  Fetch.useFetchDatasourceFeatures({ category, code }, readStatus);
  return (
    <DatasetWizardContentContainer
      category={category}
      className="aridhia-add-dataset-resources"
      code={code}
      readErrors={readErrors}
      title={title}
    >
      {canConvert && (<ConvertMessage isDirty={isDirty} />)}
      <DatasetAttachmentsTable code={code} category={category} />
    </DatasetWizardContentContainer>
  );
};

export default AddDatasetAttachments;
